import {_utils, viewportChecker} from "../../../utils/_utils.js";
import {_state} from "../../../state/state.js";
import {_libs} from "../../../utils/_libs.js";
import gsap from "gsap";

export const heroHomeBlock = () => {
    return new Promise((resolve, reject) => {
        _utils.initSection('.hero-home', (section, sectionIndex) => init(section, sectionIndex));
        resolve();
    })
}

const init = (section, sectionIndex) => {
    const truck = section.querySelector('.hero-home__road-truck');

    let tl = null;

    const createTruckAnim = () => {

        if(tl !== null){
            tl.scrollTrigger.kill(true);
            tl.kill();
            tl = null;
        }
        if(_state.isDesktop && truck){

            tl = gsap.to(truck, {
                y: 0,
                ease: "none",
                scrollTrigger: {
                    trigger: section,
                    start: "top top",
                    end: "+=100%",
                    scrub: true,
                    pin: true
                }
            });
        }
    }

    createTruckAnim();

    const rebuildFunc = () => {
        if(_state.isUserActive){
            createTruckAnim();
        }
    }
    _utils.rebuildComponentsOnResize(rebuildFunc);

}